import { Button, Grid } from '@material-ui/core'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { GridItem } from '../../../../shared/grid-item'
import { MainPageHowItWorksCard } from '../main-page-how-it-works-card'
import { MainPageSectionHeader } from '../main-page-section-header'
import { useMainPageStepsSectionStyles } from './main-page-steps-section.styles'

function cardImageSrc(step: 1 | 2 | 3 | 4): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  return `${base}/images/how-it-works/step-${step}.jpg`
}

export const MainPageStepsSection: React.FC = () => {
  const classes = useMainPageStepsSectionStyles()
  const { t } = useTranslation()

  const cards = useMemo(
    () => [
      {
        label: t('mainPage.howItWorksSection.cards.0.label'),
        pill: t('mainPage.howItWorksSection.cards.0.pill'),
        to: '/donate',
        imageSrc: cardImageSrc(1),
      },
      {
        label: t('mainPage.howItWorksSection.cards.1.label'),
        pill: t('mainPage.howItWorksSection.cards.1.pill'),
        to: '/nonprofit-catalog',
        imageSrc: cardImageSrc(2),
      },
      {
        label: t('mainPage.howItWorksSection.cards.2.label'),
        pill: t('mainPage.howItWorksSection.cards.2.pill'),
        to: '/search',
        imageSrc: cardImageSrc(3),
      },
      {
        label: t('mainPage.howItWorksSection.cards.3.label'),
        pill: t('mainPage.howItWorksSection.cards.3.pill'),
        to: '/charity',
        imageSrc: cardImageSrc(4),
      },
    ],
    [t]
  )

  return (
    <section className={classes.root} aria-labelledby="how-it-works-heading">
      <div className={classes.inner}>
        <MainPageSectionHeader
          titleId="how-it-works-heading"
          title={t('mainPage.howItWorksSection.title')}
          subtitle={t('mainPage.howItWorksSection.subtitle')}
          action={
            <Button
              color="primary"
              component={Link}
              variant="contained"
              disableElevation
              to="/nonprofit-catalog"
            >
              {t('mainPage.howItWorksSection.seeAllNgos')}
            </Button>
          }
        />

        <Grid container spacing={3}>
          {cards.map((card) => (
            <GridItem xs={12} sm={6} md={3} key={card.to + card.label}>
              <MainPageHowItWorksCard
                label={card.label}
                pill={card.pill}
                imageSrc={card.imageSrc}
                to={card.to}
                linkAriaLabel={t('mainPage.howItWorksSection.cardAria', {
                  pill: card.pill,
                })}
              />
            </GridItem>
          ))}
        </Grid>
      </div>
    </section>
  )
}
